export default __webpack_public_path__ + "static/media/money-back@3x.ac767a20.png";